import { createQueryKeys } from '@lukemorales/query-key-factory'

export const connectionCheckerQueryParams = createQueryKeys(
  'CONNECTION_CHECKER',
  {
    ping: null,
  },
)
